import classNames from 'classnames';
import { Switch, Route } from 'react-router-dom';
import { GetDefaultMainNavItems } from '../../../../../store/utils/create-event';
import { NavMainItems, NavProfileItems } from '../../../../../types/working-model';
import { ICONS } from '../../../../general-ui/icon';
import People from './people';
import Home from './home';
import MainPreview, { PostRegisterSideBar } from './main-preview';
import SessionItemsList from './session-items-list';
import SessionView from '../../../../live-event/session/session';
import { PATHNAMES } from '../../../admin';
import React, { useRef } from 'react';
import { useTypedSelector } from '../../../../../store/reducers/use-typed-selector';
import { TemplateClassNames } from '../../../../../types/template-layouts';
// import './post-regist-preview.scss'; 
//If working on Sessions tab of Main navigation, this file contains some old styling for the editor sessions view that may be helpful, but importing this fully messes up the editor window. Please find a way to separate out the necessary styling into a separate file, or go through and make sure to remove anything effecting the editor window sizing and position/margin


export const mainNavIcons = (name: NavMainItems): string | null => {
	switch (name) {
		case NavMainItems.Home: return ICONS.HOME;
		case NavMainItems.Sessions: return ICONS.CALENDAR;
		case NavMainItems.People: return ICONS.PEOPLE_NAV;
		case NavMainItems.Session: return ICONS.CALENDAR;
	}
	return null;
};

export const profileNavIcons = (name: NavProfileItems): string | null => {
	if (name === NavProfileItems.Profile) return ICONS.PERSON;
	return null;
};

const PostRegisterPreview: React.FC = () => {

	const workingEvent = useTypedSelector(state => state.CreateEventReducer.workingEvent);
	const editorSize = useTypedSelector(state => state.CreateEventReducer.editorSize);
	const panelOpen = useTypedSelector(state => state.EventPanelReducer.panelOpen);
	const logo = useTypedSelector(state => state.CreateEventReducer?.workingEvent?.homepage?.header?.logo);
	const _template = useTypedSelector(state => state.CreateEventReducer.workingEvent?.template.name);

	// Gets forwarded to child homepage component for auto scrolling on module clicks
	const previewContainerRef = useRef<HTMLDivElement | null>(null);

	const isSingleSession = workingEvent?.sessions.length === 1;
	const hasHomepage = workingEvent?.homepage;

	const eventMainNavItems = workingEvent?.homepage?.event_main_nav_items || GetDefaultMainNavItems(isSingleSession);
	// access to profile nav items is here (need to ask design team some questions about them before trying to implement):
	// const eventProfileNavItems = workingEvent?.homepage?.event_profile_nav_items || GetDefaultProfileNavItems();

	if (!workingEvent) return null;
	return (
		<div
			className={classNames("post-register-preview editor-main-border")}
		>
			<div
				ref={previewContainerRef}
				className={classNames("post-register-preview-container", "editor editor-main-container live-event-container", editorSize, { 'panel-open': !!panelOpen })}
			>
				<Switch>
					<Route path={PATHNAMES.Event.HomePath}>
						<Home
							navItem={eventMainNavItems.find(item => item.name === NavMainItems.Home)}
							eventMainNavItems={eventMainNavItems}
							ref={previewContainerRef}
						/>
					</Route>
					<Route path={PATHNAMES.Event.PeoplePath}>
						<People navItem={eventMainNavItems.find(item => item.name === NavMainItems.People)} />
					</Route>
					<Route path={PATHNAMES.Event.SessionsPath}>
						<SessionItemsList eventMainNavItems={eventMainNavItems} />
					</Route>
					<Route>
						{isSingleSession ? (
							<>
								{hasHomepage && (
									<PostRegisterSideBar {...{ eventMainNavItems, template: _template ? TemplateClassNames[_template] : TemplateClassNames.Apollo, logo }} activeMenuItem={NavMainItems.Session} />
								)}
								<SessionView singleSession previewBundle={workingEvent} />
							</>
						) : (
							<MainPreview eventMainNavItems={eventMainNavItems} />
						)}
					</Route>
				</Switch>
			</div>
		</div>
	);
};

export default PostRegisterPreview;
